document.addEventListener('click', (e) => {
    const sample_button = e.target.closest('.button_add_sample');

    if (!sample_button) return; // Ignore clicks outside .button_add_sample

    const thisButton = sample_button.closest('button');
    thisButton.classList.add('loading');
    thisButton.setAttribute('aria-disabled', true);
    const variant_id = thisButton.getAttribute('data-id');
    let customer_is_b2b = false;

    if(sample_button.hasAttribute('data-b2bprice')) {
        customer_is_b2b = true;
    }


    // hook into the product.js scripts:
    let product_form = document.querySelector('product-form');
    if (product_form == null) {
        product_form = document.querySelector('product-card');
    }

    let formData = {
        'items': [{
            'id': variant_id,
            'quantity': 1
        }],
        'sections': product_form.getSectionsToRender().map((section) => section.section),
        'sections_url': window.location.pathname
    };



    if(customer_is_b2b){
       
            formData.items[0]['properties'] = { '_B2B Price': sample_button.getAttribute('data-b2bprice') };
       }


    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then((response) => response.json())
        .then((response) => {
            // check if that's the limit now, and if so, hide all sample buttons
            let numberOfFreeItemsInCart = 0;
            let duplicateWholeTile = false;
                       for (const item of response.items) {
                if (item.sku.charAt(0) === '/') {
                    duplicateWholeTile = true;
                }
            }

            if (duplicateWholeTile) {
                if(thisButton.hasAttribute("data-already")) {
                    let replacementButtonMarkup = document.createElement("div");
                    replacementButtonMarkup.classList.add('sample_already_added');
                    replacementButtonMarkup.innerHTML = thisButton.getAttribute("data-already");
                    thisButton.replaceWith(replacementButtonMarkup);
                } else {
                    thisButton.style.display = 'none';
                }
                
            }

            if (response.status) {
                dispatchCustomEvent('product:variant-error', {
                    source: 'product-form',
                    productVariantId: formData.items[0].id,
                    errors: response.description,
                    message: response.message
                });
                if (response.status === 422) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                }
                product_form.handleErrorMessage(response.description);
                return;
            }

            product_form.renderContents(response);

            dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
            });
        })
        .catch((error) => {
            console.error('Error:', error);
        })
        .finally(() => {
            thisButton.classList.remove('loading');
            thisButton.removeAttribute('aria-disabled');
        });
});





function downloadResource(e) {
    if(e) {
        e.preventDefault();
        e.stopPropagation();
    }
console.log("e");
    const url=e.target.closest('.forceDownload').getAttribute('href');
    const filename=e.target.closest('.forceDownload').getAttribute('data-title');

    fetch(url, {
      headers: new Headers({
        'Origin': location.origin
      }),
      mode: 'cors'
    })
    .then(response => response.blob())
    .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch(e => console.error(e));
}

function forceDownload(blob, filename) {
    var a = document.createElement('a');
    a.download = filename;
    a.href = blob;
    document.body.appendChild(a);
    a.click();
    a.remove();
}

document.addEventListener("DOMContentLoaded", function() {
    const allDownloadButtons = document.querySelectorAll('.forceDownload');
    if (allDownloadButtons.length > 0) {
      for (i = 0; i < allDownloadButtons.length; i++) {
        allDownloadButtons[i].onclick = downloadResource;
      }
    }
});

